import React from 'react';
import { StarIcon } from '@heroicons/react/24/solid';

export default function Testimonial() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-indigo-600 to-indigo-700 rounded-3xl p-8 lg:p-12 relative overflow-hidden">
          {/* Decorative blobs */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500 rounded-full opacity-30 translate-x-20 -translate-y-20 blur-3xl pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-500 rounded-full opacity-20 -translate-x-16 translate-y-16 blur-3xl pointer-events-none" />

          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <StarIcon key={i} className="w-5 h-5 text-yellow-300" />
                ))}
              </div>
              <p className="text-2xl lg:text-3xl font-bold text-white leading-snug mb-6">
                "We switched for the accuracy. We stayed for everything else"
              </p>
              <p className="text-indigo-200 text-base leading-relaxed mb-8">
                Director Discovery was the first platform where we didn't have to second-guess the data. Every email, every phone number — it just works. Broad coverage, smart filters, and a Chrome extension that works anywhere. It's now the backbone of our outbound.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-indigo-400 flex items-center justify-center text-white font-bold text-sm">JW</div>
                <div>
                  <p className="text-white font-semibold text-sm">Josh Whitfield</p>
                  <p className="text-indigo-300 text-xs">Founder at CMM</p>
                </div>
              </div>
            </div>

            {/* Right side — mini dashboard card */}
            <div className="flex justify-center lg:justify-end">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 w-full max-w-sm border border-white/20">
                <p className="text-xs text-indigo-200 font-semibold uppercase tracking-wider mb-4">Live results</p>
                {[
                  { label: 'Emails found', pct: 98, val: '11,203' },
                  { label: 'Verified contacts', pct: 94, val: '9,841' },
                  { label: 'Mobile numbers', pct: 72, val: '4,561' },
                ].map((item) => (
                  <div key={item.label} className="mb-4">
                    <div className="flex justify-between text-sm text-white mb-1">
                      <span>{item.label}</span>
                      <span className="font-semibold">{item.val}</span>
                    </div>
                    <div className="h-1.5 bg-white/20 rounded-full">
                      <div className="h-1.5 bg-white rounded-full transition-all" style={{ width: `${item.pct}%` }} />
                    </div>
                  </div>
                ))}
                <div className="mt-5 pt-4 border-t border-white/20 flex items-center justify-between">
                  <span className="text-indigo-200 text-xs">Bounce rate</span>
                  <span className="text-green-300 font-bold text-sm">↓ 70% lower</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
